import { Component, ViewChild, ViewContainerRef } from "@angular/core";
import { NgIf } from "@angular/common";
import { PopupPageComponent } from "@components";
import { PopupService } from "@core";

@Component({
  selector: "app-popup-container",
  standalone: true,
  imports: [NgIf, PopupPageComponent],
  templateUrl: "./popup-container.component.html",
  styleUrl: "./popup-container.component.scss",
})
export class PopupContainerComponent {
  @ViewChild("popupFrame", { read: ViewContainerRef }) popupFrame!: ViewContainerRef;

  constructor(private _popupService: PopupService) {
    this._popupService.toShowComponent$.subscribe((component) => {
      if (component) {
        this.popupFrame.clear();
        this.popupFrame.createComponent(component);
      } else {
        this.popupFrame.clear();
      }
    });
  }
}
